module.exports = __webpack_public_path__ + "static/vityazPrivatbank-69ecd66836deaf20c3a438804e5dd6ac.webp";